import React from "react";

export default function Gear() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      viewBox="0 0 33 33"
      fill="none"
    >
      <path stroke="#DDE0E4" strokeWidth={5} d="M3.126 3.001h27v27h-27z" />
      <path
        fill="#000"
        d="M15.735 10.478a.618.618 0 0 1 .78 0l.755.614a.618.618 0 0 0 .487.13l.96-.153a.618.618 0 0 1 .676.39l.347.909a.617.617 0 0 0 .357.357l.91.346a.618.618 0 0 1 .389.676l-.154.96a.618.618 0 0 0 .13.488l.614.755a.618.618 0 0 1 0 .78l-.614.754a.618.618 0 0 0-.13.488l.154.96a.618.618 0 0 1-.39.676l-.909.347a.618.618 0 0 0-.357.357l-.347.909a.618.618 0 0 1-.675.39l-.96-.155a.618.618 0 0 0-.488.131l-.755.614a.618.618 0 0 1-.78 0l-.755-.614a.618.618 0 0 0-.488-.13l-.96.154a.618.618 0 0 1-.675-.39l-.347-.91a.618.618 0 0 0-.357-.356l-.91-.347a.618.618 0 0 1-.39-.675l.155-.96a.618.618 0 0 0-.13-.489l-.615-.754a.618.618 0 0 1 0-.78l.614-.755a.618.618 0 0 0 .131-.488l-.154-.96a.618.618 0 0 1 .39-.676l.909-.346a.618.618 0 0 0 .357-.357l.347-.91a.618.618 0 0 1 .675-.39l.96.155a.618.618 0 0 0 .488-.13l.755-.615Z"
      />
    </svg>
  );
}
